import React from 'react';
import { Calendar, User, BookOpen, Target, FileText, Laptop, TrendingUp, ClipboardCheck } from 'lucide-react';
import { Card } from '../ui/card';
import { whyChooseUs } from '../../mockData';

const iconMap = {
  Calendar,
  User,
  BookOpen,
  Target,
  FileText,
  Laptop,
  TrendingUp,
  ClipboardCheck
};

const WhyChooseUsSection = () => {
  return (
    <section className="section-light">
      <div className="section-container">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="accent-bar"></div>
          <h2 className="heading-lg mb-6">Why Students & Parents Choose Us</h2>
          <p className="body-lg" style={{ color: 'var(--text-grey)' }}>
            We provide personalized, exam-focused coaching that delivers real results. Our structured approach helps students build confidence, master exam strategies, and achieve their target scores.
          </p>
        </div>
        <div className="grid-3">
          {whyChooseUs.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <Card key={item.id} className="premium-card text-center">
                <div className="flex justify-center mb-6">
                  <div className="icon-container">
                    <IconComponent className="w-9 h-9" style={{ color: 'var(--accent-teal)' }} />
                  </div>
                </div>
                <h3 className="heading-sm mb-4">{item.title}</h3>
                <p className="body-md" style={{ color: 'var(--text-grey)' }}>{item.description}</p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
